import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { NgForOf } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'error-404',
  providers: [],
  styleUrls: ['./error-404.scss'],
  standalone: true,
  imports: [
    NgForOf,
    TranslateModule,
    MatButton,
    RouterLink
  ],
  templateUrl: './error-404.html'
})
export class Error404Component implements AfterViewInit {
    @Input()
    public message = '';
    @Input()
    public actions: any[] = [{ name: 'Okay_then...', link: '/' }];
    constructor(
        private config: ConfigProvider,
        private translateService: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }
}
